const colorMap = {
  "Blue": "#0000ff",
  "Sky": "#87cfeb",
  "White": "#ffffff",
  "Red": "#ff0000",
  "Others": "#808080",
  "Pink": "#ffc0cb",
  "Black": "#000000",
  "Navy": "#000080",
  "Green": "#00ff00",
  "Cream": "#fffdd0",
  "Beige": "#f5f5dc",
  "Brown": "#964b00",
  "Yellow": "#ffff00",
  "Lilac": "#c8a2c8",
  "Maroon": "#800000",
  "Orange": "#ffa600",
  "Light Grey": "#d3d3d3",
  "Olive": "#808000",
  "Purple": "#a020f0",
  "Dark Grey": "#a9a9a9",
  "Sand": "#c2b180",
  "Black & White": "#000000",
  "Rust": "#b7410e",
  "Gold": "#ffd900",
  "Ochre": "#cc7722",
  "Teal": "#008080",
  "Grey": "#808080",
  "Ink": "#27221f",
  "Lime": "#00ff00",
  "Turquoise": "#40e0d0",
  "Anthra": "#353c40",
  "Aqua": "#00ffff",
  "Mustard": "#ffdb58",
  "Sea Green": "#2e8b56",
  "Burgundy": "#800020",
  "Cobalt": "#0047ab",
  "Mint": "#3eb489",
  "Chocolate": "#7b4000",
  "Coral": "#ff7f50",
  "Dark Pink": "#aa336a",
  "Dark Red": "#8b0000",
  "Ecru": "#c2b180",
  "Khaki": "#f0e68c",
  "Dark Blue": "#00008b",
  "Dark Maroon": "#3c0008",
  "Medium Grey": "#a9a9a9",
  "Rose": "#ff0080",
  "Stone": "#ada587",
  "Camel": "#c19a6b",
  "Charcoal": "#36454f",
  "Medium Red": "#8b0000",
  "Peach": "#ffe5b4",
  "Royal": "#4169e1",
  "Tangerine": "#f28500",
  "Aubergine": "#614051",
  "Dark Brown": "#654321",
  "Dark Gold": "#ffd900",
  "Dark Green": "#013220",
  "Dark Olive": "#556b2f",
  "Jade": "#00a86a",
  "Light Blue": "#add8e6",
  "Light Brown": "#c4a484",
  "Medium Blue": "#0000cd",
  "Medium Brown": "#7f5212",
  "Silver": "#c0c0c0",
  "Tan": "#d2b48c",
  "Wine": "#722f37"
};



window.onWizzyScriptLoaded = function () {

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      // console.log(payload, "BEFORE_LAZY_INIT");
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      if (!Array.isArray(window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers)) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [];
      }
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // console.log(payload, "BEFORE_INIT");
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      if (!Array.isArray(window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers)) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [];
      }
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")
      
      payload.forEach(product => {

        if (!product.attributes?.length) return;

        product.attributes.forEach(attr => {

          // -----------------------------------
          // Product Handle
          // -----------------------------------
          if (
            attr.id === "product_handle" &&
            attr.values?.length
          ) {
            product.productHandle = attr.values[0]?.value?.[0] || "";
          }

          // -----------------------------------
          // Product Handle
          // -----------------------------------
          if (
            attr.id === "product_product_sale_badge_custom" &&
            attr.values?.length
          ) {
            product.productSaleBadge = attr.values[0]?.value?.[0] || "";
          }

          // -----------------------------------
          // Product Rating Reviews
          // -----------------------------------
          if (
            attr.id === "product_rating_reviews" &&
            attr.values?.length
          ) {
            const ratingValue = attr.values[0]?.value?.[0];

            try {
              const ratingObj = JSON.parse(ratingValue);

              // Add the complete object if needed
              product.ratingReviews = ratingObj;

              // Or add individual fields
              product.averageRating = parseFloat(ratingObj.value || 0);
              //product.ratingScaleMin = parseFloat(ratingObj.scale_min || 0);
              //product.ratingScaleMax = parseFloat(ratingObj.scale_max || 0);

              let ratingAvg = parseFloat(ratingObj.value || 0);
              if(ratingAvg > 0) {
                product.presentReview = true;
              }

            } catch (e) {
              console.error("Failed to parse product_rating_reviews", e);
            }
          }

          if (
            attr.id === "product_type" &&
            attr.values?.length
          ) {
            product.flitsProductType = attr.values[0]?.value?.[0] || "";
          }

          if (
            attr.id === "product_collections" &&
            attr.values?.length
          ) {
            product.flitsProductCollections = attr.values[0]?.value?.[0] || "";
          }

          if (
            attr.id === "product_wsl_count" &&
            attr.values?.length
          ) {
            product.flitsWslCount = attr.values[0]?.value?.[0] || "0";
          }

        });

        // Flits wishlist placeholders (collection card expects cents + base64 title)
        const selling = parseFloat(product.sellingPrice) || 0;
        const compare = parseFloat(product.price) || 0;
        product.flitsProductTitle = btoa(
          encodeURIComponent(product.name || "").replace(/%20/g, "+")
        );
        product.flitsProductPrice = Math.round(selling * 100);
        product.flitsProductDiscount =
          compare > selling ? Math.round((compare - selling) * 100) : 0;
        product.flitsWslCount = product.flitsWslCount || "0";
        product.flitsProductCollections = product.flitsProductCollections || "";
        product.flitsProductType = product.flitsProductType || "";

      });


      payload.forEach((product) => {
        if (
          (product.price &&
            product.price.endsWith(".00") &&
            (product.price = product.price.slice(0, -3)),
          product.sellingPrice &&
            product.sellingPrice.endsWith(".00") &&
            (product.sellingPrice = product.sellingPrice.slice(0, -3)),
          product.discount)
        ) {
          product.discount.endsWith(".00") &&
            (product.discount = product.discount.slice(0, -3));
          // var discountPrice = product.discount;
          // discountPrice && (product.discount = discountPrice.replace(/,/g, ""))
        }
      });


        payload.forEach((product) => {
            if (product.groupId === "" || product.groupId === null) {
                if (typeof product.attributes !== "undefined" && Array.isArray(product.attributes)) {
                    product.attributes.forEach((attr) => {
                        if (attr.id === "product_variant_ids") {
                        if (typeof product.singleVarientGroupId === "undefined") {
                            product.singleVarientGroupId = product.id
                            product.id = attr.values[0].value[0];
                        }
                        }
                    })
                }
            }
        })
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      initWizzyAutocompleteOpenClass();


      const storageKey = "wizzy_store";
      const store = JSON.parse(localStorage.getItem(storageKey));

      if (store && Array.isArray(store.SEARCHED_KEYWORDS)) {
          const seen = new Set();

          store.SEARCHED_KEYWORDS = store.SEARCHED_KEYWORDS.filter(item => {
              const term = item?.searchTerm?.trim().toLowerCase();

              if (!term) return true;

              if (seen.has(term)) {
                  return false; // Duplicate found
              }

              seen.add(term);
              return true;
          });

          localStorage.setItem(storageKey, JSON.stringify(store));
      }
      
      return data;
    })

     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      const predictiveSearch = document.querySelector('predictive-search');
      if (predictiveSearch && predictiveSearch.classList.contains('is-active')) {
        predictiveSearch.classList.remove('is-active');
      }

      const closeButton = document.querySelector('.btn--close-search');
      if (closeButton) {
        closeButton.click();
      }

      if (document.documentElement.clientWidth > 768) {
        const searchContainer = document.querySelector('.site-header__search-container');
        if (searchContainer) {
            searchContainer.classList.remove('open-force', 'is-transitioning');
        }
      }


      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
        function (payload) {
        // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");      
        return payload;
        }
    );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");
      initWizzyAddToCart();
      initLayoutToggle();
      initWizzyWishlist();

      const total = data?.data?.response?.payload?.total;
      if (total === 1) {
          document.body.classList.add("wizzy-single-result");
      } else {
          document.body.classList.remove("wizzy-single-result");
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");
      initWizzyAddToCart();
      initLayoutToggle();
      initWizzyWishlist();


      const body = document.body;
      if (body && !body.classList.contains('wizzy-search-results-rendered')) {
          body.classList.add('wizzy-search-results-rendered');
      }

      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      console.log(payload,"BEFORE_RENDER_RESULTS");

      if (payload.response.payload.facets) {
        payload.response.payload.facets.forEach((facet) => {
          if (facet.key === "product_colour_custom") {
            const ColorData = facet.data;
            if (ColorData) {
              ColorData.forEach(color => {
                if(colorMap[color.label]){
                  // color.isVisualSwatch = true;
                  // color.isSwatch = true;
                  color.swatchValue = colorMap[color.label];
                }
                color.isVisualSwatch = true;
                color.isSwatch = true;
                // console.log(color.isVisualSwatch, "Wizzy isVisualSwatch");
              });
              facet.data = ColorData;
            }
          }
        });
      }
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      initWizzyAddToCart();
      return payload;
    }
  );
};


/////////////////////////////////////////////////


// Function 2: Attach click events (prevent duplicate binding)
function initLayoutToggle() {
    const buttons = document.querySelectorAll('.collection-view-switcher button');
    const wrapper = document.querySelector('.wizzy-search-wrapper');

    if (!buttons.length || !wrapper) return;

    buttons.forEach(btn => {
        // Prevent multiple event bindings
        if (btn.dataset.listenerAttached === 'true') return;

        btn.addEventListener('click', function () {
            let layoutLevel = this.dataset.cols === '2' ? '2' : '1';

            // Update DOM
            wrapper.setAttribute('wizzy-grid-view-level', layoutLevel);

            // Save to sessionStorage
            sessionStorage.setItem('wizzyLayout', layoutLevel);

            // Update active state
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
        });

        // Mark as attached
        btn.dataset.listenerAttached = 'true';
    });
}



///////////////////////////////////////////////


var _wizzyAutocompleteObserverReady = false;

function initWizzyAutocompleteOpenClass() {
  if (_wizzyAutocompleteObserverReady) return;

  var body = document.body;
  var wrapper = document.querySelector(".wizzy-body-end-wrapper");
  if (!body || !wrapper) return;

  _wizzyAutocompleteObserverReady = true;

  function toggleClass() {
    var autocomplete = wrapper.querySelector(".wizzy-autocomplete-wrapper");
    if (autocomplete && getComputedStyle(autocomplete).display === "flex") {
      body.classList.add("wizzy-autocomplete-open");
    } else {
      body.classList.remove("wizzy-autocomplete-open");
    }
  }

  toggleClass();

  new MutationObserver(toggleClass).observe(wrapper, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"],
  });
}

function waitForWizzyBodyEndWrapper() {
  if (document.querySelector(".wizzy-body-end-wrapper")) {
    initWizzyAutocompleteOpenClass();
    return;
  }

  var waiter = new MutationObserver(function () {
    if (document.querySelector(".wizzy-body-end-wrapper")) {
      waiter.disconnect();
      initWizzyAutocompleteOpenClass();
    }
  });

  waiter.observe(document.body, { childList: true, subtree: true });
}

waitForWizzyBodyEndWrapper();


// -------------------------------------------------------------------
// Add-to-cart binding for Wizzy-rendered results
// -------------------------------------------------------------------
// The theme binds theme.AjaxProduct to product forms once, on DOMContentLoaded
// (see common-js.liquid). Wizzy injects its result cards after that, so their
// forms have no submit handler. Re-run the theme's initialiser after each
// render. It is idempotent (data-ajax-product-init guard) and retries a few
// times to cover theme.AjaxProduct not being ready on the first render.
function initWizzyAddToCart(attempt) {
  attempt = attempt || 0;
  try {
    if (typeof theme !== "undefined" && typeof theme.AjaxProduct === "function") {
      document.querySelectorAll(".product-single__form").forEach(function (form) {
        if (form.dataset.ajaxProductInit === "true") return; // already bound
        form.dataset.ajaxProductInit = "true";
        new theme.AjaxProduct(form); // theme.js global
      });
    }
  } catch (e) {
    /* no-op */
  }
  if (attempt < 10) {
    setTimeout(function () {
      initWizzyAddToCart(attempt + 1);
    }, 300);
  }
}


// -------------------------------------------------------------------
// Wishlist binding for Wizzy-rendered results (Flits)
// -------------------------------------------------------------------
// Flits collection wishlist scans .flits-collection-page-wishlist-button
// once on load and again on Flits:AjaxCollection:CollectionUpdated.
// Wizzy injects cards after that lifecycle, so we re-dispatch the event
// after each render (initial search, refresh, pagination / infinite scroll).
var FLITS_COLLECTION_UPDATE_EVENT = "Flits:AjaxCollection:CollectionUpdated";

function initWizzyWishlist(attempt) {
  attempt = attempt || 0;
  try {
    document.dispatchEvent(
      new CustomEvent(FLITS_COLLECTION_UPDATE_EVENT, {
        bubbles: true,
        detail: { source: "wizzy" },
      })
    );
  } catch (e) {
    /* no-op */
  }
  // Flits rescans buttons on a 1s delay; retry while its module may still be loading.
  if (attempt < 8) {
    setTimeout(function () {
      initWizzyWishlist(attempt + 1);
    }, 400);
  }
}


// ----------------------------------------------------------------------------


function toggleScrolledClass() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = (scrollTop / docHeight) * 100;

  if (scrollPercent >= 9) {
    document.body.classList.add("wizzy-scrolled");
  } else {
    document.body.classList.remove("wizzy-scrolled");
  }
}

window.addEventListener("scroll", toggleScrolledClass);
window.addEventListener("load", toggleScrolledClass);


// ----------------------------------------------------------------------------



const searchIcon = document.querySelector('.site-nav__link .icon-search');

if (searchIcon) {
    searchIcon.addEventListener('click', function () {
      setTimeout(() => {
          const searchInput = document.querySelector('.search__input.wizzy-search-input');
          const modelOpen = document.querySelector('.site-header__search-container.open-force');
          console.log(modelOpen,"modelOpen");
          if (searchInput && modelOpen !== null) {
              searchInput.click();
          } else {
              console.log('Search input not found.');
          }
        }, 500);

    });
} else {
    console.log('Search icon not found.');
}


// -------------------------------------------------------------------------------


if (window.innerWidth > 768) {
    const observer = new MutationObserver(() => {
        if (document.body.classList.contains('wizzy-search-results-rendered')) {
            document
                .querySelector('.site-header.site-header--heading-style')
                ?.classList.add('site-header--stuck', 'site-header--opening');
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
}